module.exports = __webpack_public_path__ + "img/img12.c48286ca.jpg";